import type { QueryClient } from '@tanstack/react-query';

import { invalidateAIPromptCommands } from '@/hooks/api/useAIPromptCommands';
import { creditsKeys } from '@/hooks/api/useCredits';
import { invalidateDigitalHumanVerification } from '@/hooks/api/useDigitalHumanVerification';
import { invalidateDigitalHumans } from '@/hooks/api/useDigitalHumans';
import { folderKeys } from '@/hooks/api/useFolders';
import { projectKeys } from '@/hooks/api/useProjects';
import { screenplayKeys } from '@/hooks/api/useScreenplays';
import { storyboardReviewKeys } from '@/hooks/api/storyboardReviewKeys';
import { storyboardKeys } from '@/hooks/api/useStoryboards';

export function invalidateContextDependentQueries(queryClient: QueryClient): void {
  queryClient.invalidateQueries({ queryKey: projectKeys.all });
  queryClient.invalidateQueries({ queryKey: folderKeys.all });
  queryClient.invalidateQueries({ queryKey: creditsKeys.all });
  queryClient.invalidateQueries({ queryKey: ['org-members'] });
  queryClient.invalidateQueries({ queryKey: ['org'] });
  queryClient.invalidateQueries({ queryKey: ['context-resource-summary'] });
  queryClient.invalidateQueries({ queryKey: ['project-shares', 'functional-roles'] });
  queryClient.invalidateQueries({ queryKey: ['project-permission-groups'] });
  queryClient.invalidateQueries({ queryKey: ['org-members-available-for-project'] });
  queryClient.invalidateQueries({ queryKey: screenplayKeys.all });
  queryClient.invalidateQueries({ queryKey: storyboardKeys.all });
  queryClient.invalidateQueries({ queryKey: storyboardReviewKeys.all });
  invalidateAIPromptCommands(queryClient);
  invalidateDigitalHumans(queryClient);
  invalidateDigitalHumanVerification(queryClient);
}
